
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/marketing/newsletter",
      function () {
        return require("private-next-pages/admin/marketing/newsletter/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/marketing/newsletter"])
      });
    }
  